module.exports = __webpack_public_path__ + "img/status-change.5b631f2e.png";